import { Button, PageHeader } from '@my/ui';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Check templates list — placeholder. Templates define the inspection items
 * an operator steps through on each walk-around. Wire the real CRUD screen in
 * once the Safety API lands.
 */
export function TemplateListPage() {
  const { t } = useTranslation('checks');

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <PageHeader title={t('templates.title')} description={t('templates.description')}>
        <Button>
          <Plus className="h-4 w-4" />
          {t('templates.add')}
        </Button>
      </PageHeader>
      <section className="mt-6 rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
        <p className="text-sm text-slate-500">{t('templates.comingSoon')}</p>
      </section>
    </div>
  );
}
